import type * as React from "react";
import { cn } from "../lib/cn.js";

export const fieldClasses =
  "w-full min-w-0 border border-input bg-inset px-3 text-sm text-foreground caret-brand outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-faint-foreground focus-visible:border-ring focus-visible:ring-4 focus-visible:ring-ring/10 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive";

export function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return <input type={type} className={cn(fieldClasses, "h-9", className)} {...props} />;
}
